var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"auto"}},[(_vm.isLoaded)?_c('div',[_c('FindPositionProResult',{attrs:{"positions-arr":_vm.positions,"show-graph":false,"grouped-data":_vm.grouped_data,"is-top-btn-hidden":true}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }